import {
  IHstSyncStatsResponse,
  IHstSyncRecordsResponse,
  IHstSyncRecordsRequest,
} from "types/HstSync";

import { api } from ".";

const buildURLForHstSyncs = ({
  patientName,
  status,
  page,
  pageSize,
}: IHstSyncRecordsRequest): string => {
  const baseUrl = "/hst-sync/syncs";
  const params: string[] = [];

  if (patientName && patientName.length > 0) {
    params.push(`patientName=${encodeURIComponent(patientName)}`);
  }
  if (status) {
    params.push(`status=${status}`);
  }
  if (page !== undefined) {
    params.push(`page=${page}`);
  }
  if (pageSize !== undefined) {
    params.push(`pageSize=${pageSize}`);
  }

  return params.length > 0 ? `${baseUrl}?${params.join("&")}` : baseUrl;
};

const hstSyncQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getHstSyncStats: builder.query<IHstSyncStatsResponse, void>({
      query: () => "/hst-sync/syncs/stats",
    }),
    getHstSyncRecords: builder.query<
      IHstSyncRecordsResponse,
      IHstSyncRecordsRequest
    >({
      query: (params) => buildURLForHstSyncs(params),
    }),
  }),
});

export const { useGetHstSyncStatsQuery, useGetHstSyncRecordsQuery } =
  hstSyncQueries;
